export default "__VITE_ASSET__DIE5LpN5__"